import { Entity, QueryParams } from "..";

export interface PageParams {
    page?: number;
    pageSize?: number;
}

export interface SortParams {
    orderBy: string;
    orderDesc: string;
}

export interface ParamsConfig {
    pageParams: PageParams;
    sortParams: SortParams;
    queryParams: QueryParams;
}

export type IParams = Record<Entity, ParamsConfig>;

export const DefaultSortParams: SortParams = {
    orderBy: "",
    orderDesc: "",
};

export const DefaultPageParams: PageParams = {
    page: 1,
    pageSize: 10,
};
